"use client";
import { Carousel, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import PerformanceContents from "./carousel-content";
import { PerformancesSectionProps } from "@/services/home/types";
import { Lang } from "@/i18n/settings";
import { Shell } from "@/components/ui/shell";
import Carpet from "@/components/ui/Carpet";

type Props = {
  data: PerformancesSectionProps;
  lang: Lang;
};

export default function Performances({ data, lang }: Readonly<Props>) {
  return (
    <Carpet type="fade-light" className="relative -mb-[31.875rem] pb-[31.875rem]">
      <Carousel
        opts={{
          align: "start",
          direction: lang === "ar" ? "rtl" : "ltr",
          loop: true,
        }}
        className="w-full"
      >
        <Shell className="!pb-20 pt-20 sm:pt-6 lg:flex 3xl:!pb-[120px] 3xl:pt-[120px]">
          <div className="flex w-full flex-col gap-10 3xl:gap-20">
            <div className="flex items-center justify-between gap-4">
              <h1 className="text-3xl capitalize tracking-[-1.44px] text-secondary sm:text-[38px] xl:text-[48px] ltr:font-playfair">
                {data?.title}
              </h1>
              <div className="flex items-center gap-4 rtl:flex-row-reverse">
                <CarouselPrevious className="relative h-10 w-10 md:h-12 md:w-12 3xl:h-[58px] 3xl:w-[58px]" />
                <CarouselNext className="relative h-10 w-10 md:h-12 md:w-12 3xl:h-[58px] 3xl:w-[58px]" />
              </div>
            </div>

            <PerformanceContents data={data?.performances} />
          </div>
        </Shell>
      </Carousel>
    </Carpet>
  );
}
